import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Text, colors } from '@soluto-private/mx-asurion-ui-react';

import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';
import { useRepairPriceAsyncAtom } from '@service-initiation/tech-care-data-access-store';
import { getCurrencySymbol } from '@service-initiation/tech-care-utils-currency';

import { SectionContainer, SectionTitle } from '../components';

const Callout = styled.div`
  background: ${colors.neutralBrightest};
  border-radius: 8px;
  padding: 8px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TEXT = TranslationEntries.Repairs.Cart.Pricing;

export const PricingDetailsSection: FC = () => {
  const { t } = useTranslation();
  const { loading, value: repairPrice } = useRepairPriceAsyncAtom();

  return (
    <SectionContainer
      dataTestId="pricing-details-section"
      isLoading={loading}
      skeletonHeight="150px"
    >
      <SectionTitle>{t(TEXT.Title)}</SectionTitle>
      {repairPrice?.price && (
        <Row>
          <Text color={colors.neutralDeeper}>
            {t(TEXT.CrackedScreenRepairText)}
          </Text>
          <Text color={colors.neutralDeeper}>{`${getCurrencySymbol(
            repairPrice.currency
          )}${repairPrice.price}`}</Text>
        </Row>
      )}
      <Row>
        <Text weight="heavy">{t(TEXT.BottomRowLeft)}</Text>
        <Text weight="heavy">{t(TEXT.BottomRowRight)}</Text>
      </Row>
      <Callout>
        <Text size={1} weight="heavy">
          {t(TEXT.CalloutPrimaryText)}
        </Text>
        <Text color={colors.neutralDeepest} size={1}>
          {t(TEXT.CalloutSecondaryText)}
        </Text>
      </Callout>
    </SectionContainer>
  );
};
